<template>
    <div class="banner">
        <swiper :options="swiperOptiona" ref="mySwipers" class="swiper">
            <swiper-slide class="item" v-for="(item,index) in bList" :key="index">
                <img :src="`http://www.yourlonglighting.com/upload/${item.PICURL}`" alt="">
                <div class="text">
                    <span>{{item.TEXTONE}}</span>
                    <span class="lastT">{{item.TEXTTWO}}</span>
                </div>
                <div class="btn">
                    <a :href="item.HREF" target="_blank">
                    <btn-Component :text="$t('btn')"></btn-Component>
                    </a>
                </div>

            </swiper-slide>
        </swiper>
        <div class="swiper-pagination"></div>
        <div class="video-full"   :class="{ showVideo }">
            <div class="video-content">
                <div class="video-close"
                     @click="pauseVideo">
                    <i class="el-icon-close"></i>
                </div>
                <video
                        id="videoPlay01"
                        controls="controls"
                        style="z-index: 3000">
                    <source
                            type="video/mp4;"
                            src="https://www.sansg.com/video/aomate.mp4"
                            data-src="https://www.sansg.com/video/aomate.mp4">

                    你的浏览器不支持
                    <code>video</code> 标签.
                </video>
            </div>
        </div>
<!--        <div class="swiper-button-next" style="transform: rotate(180deg)">-->
<!--            <i class="iconfont icon-zuo"></i>-->
<!--        </div>-->
<!--        <div class="swiper-button-prev">-->
<!--            <i class="iconfont icon-zuo"></i>-->
<!--        </div>-->
    </div>
</template>

<script>
    import { swiper, swiperSlide } from "vue-awesome-swiper";
    import "swiper/dist/css/swiper.css";
    import btnComponent from '../components/btn'
    import { getPicUrl} from '../util/lang'
    export default {
        name: "banner",
        data(){
            return{
                showVideo:false,
                bList:[],
                swiperOptiona:{
                    pagination: {
                        el: ".banner .swiper-pagination",
                        clickable: true,
                        renderBullet: function(index, className) {
                            return '<span class="' + className + '"><i></i></span>';
                        }
                    },
                    loop: true,
                    effect: 'fade',
                    init: false,
                    nextButton:'.banner .swiper-button-next',
                    prevButton:'.banner .swiper-button-prev',
                    autoplay:{
                        disableOnInteraction: false,
                        delay:5000
                    }
                },
            }
        },
        components: {
            swiper,
            swiperSlide,
            btnComponent
        },
        mounted() {
            if(this.$i18n.locale==='en'){
                this.getList('10')
            }else{
                this.getList('8')
            }

        },
        methods:{
            pauseVideo(){
                const audioPlayer = window.document.getElementById('videoPlay01');
                audioPlayer.pause();
                this.showVideo=false
            },
            playVideo(){
                const audioPlayer = window.document.getElementById('videoPlay01');
                audioPlayer.load();
                audioPlayer.play();
                this.showVideo=true
            },
            getList(id){
                const url = `${getPicUrl( this.$i18n.locale,'首页banner',id)}`
                this.$axios.get(url).then(res => {
                    this.bList=res.data
                    console.log(this.bList)
                    this.$refs.mySwipers.swiper.init()
                })
            }
        }
    }
</script>


<style lang="scss" scoped>
    .banner{
        width:100%;
        height:100vh;
        position: relative;
        .swiper{
            height:100%;
            .item{
                position: relative;
                overflow: hidden;
                height:100%;
                img{
                    width:100%;
                    height:100%;
                    object-fit: cover;
                    display: block;
                    z-index: 1;
                    cursor: pointer;
                    transform: scale(1.1);
                    transition: all 2s;
                }
                .text{
                    z-index: 10;
                    position: absolute;
                    left: 10%;
                    top:32%;
                    width:80%;
                    display: flex;
                    flex-direction: column;
                    font-family:Calibri;
                    font-size: 50px;
                    color:white;
                    text-transform: uppercase;
                    transition: all 2s;
                    height:200px;
                    overflow: hidden;
                    span:nth-child(1){
                        color:#4F4F4F;
                        transition-delay: 600ms;
                    }
                    span:nth-child(2){
                        color:#4F4F4F;
                        font-size: 22px;
                        display: inline-block;
                        width:35%;
                        line-height: 40px;
                        margin-top: 30px;
                    }
                    span{
                        transition: all 2s;
                        transform: translateY(-200px);
                    }
                }
                .btn{
                    text-align: center;
                    position: absolute;
                    top:58%;
                    left:10%;
                }
            }
            .swiper-slide-active{
                img{
                    transform: scale(1);
                }
                .text{
                    span{
                        transform: translateY(0);
                    }
                }
            }
        }
        @media screen and (max-width:1680px){
            .swiper{
                .item{
                    .text{
                      span:nth-child(2){
                          width:40%;
                      }
                    }
                }
            }
        }
        @media screen and (max-width:1440px){
            .swiper{
                .item{
                    .text{
                        span:nth-child(2){
                            width:50%;
                        }
                    }
                }
            }
        }
        @media screen and (max-width:450px){
            .swiper{
                .item{
                    .text{
                        height:210px;
                        top:30%;
                        left:10%;
                        width:80%;
                        font-size: 25px;
                        span:nth-child(2){
                            width:100%;
                            font-size: 14px;
                        }
                    }
                    .btn{
                        bottom:5%;
                    }
                }
            }
        }
    }
</style>
<style scoped>

.banner .swiper .item.swiper-slide-active img{
    transform: scale(1);
}

    .banner .swiper-pagination {
        width:4%;
        left:45%;
        display: flex;
        flex-direction: row;
        bottom:5%;
        height:30px;
        color:white;
        font-family: "Fira Code Light";
        font-weight: lighter;
        justify-content: center;
    }
    .banner .swiper-pagination>>>.swiper-pagination-bullet {
        height:8px;
        position: relative;
        width:8px;
        border-radius: 50%;
        display: inline-block;
        background-color: #e6e6e6;
        opacity: 1;
        margin-left: 20px;
    }
    .banner .swiper-pagination>>>.swiper-pagination-bullet:focus{
        outline: none;
    }

    .banner .swiper-pagination>>>.swiper-pagination-bullet i{
        width:8px;
        height:8px;
        border-radius: 50%;
        background-color: rgba(255,255,255,.3);
        position: absolute;
        left:0;
        top:0;
    }
    .banner .swiper-pagination>>>.swiper-pagination-bullet-active i{
        width:100%;
        height:8px;
        position: absolute;
        left:0;
        top:0;
        border-radius: 50%;
        background-color: #F4A000;
        /*animation: run 5s forwards linear;*/
    }
    /*@keyframes run {*/
    /*    from {height:0;}*/
    /*    to {height:40px;}*/
    /*}*/
    .swiper-button-next{
        background-image: none;
        left:9.5%;
        top:60%;
        width:50px;
       height:60px;
    }
    .swiper-button-prev{
        background-image: none;
        left:9.5%;
        top:50%;
        width:50px;
        height:60px;
    }
video{
    border: none;
}
video:focus{
    outline: none;
}
.video-full {
    display: none;
}
.video-full.showVideo {
    display: block;
    position: fixed;
    top: 100px;
    left: 0;
    width: 100%;
    height: 90vh;
    background-color: rgba(0, 0, 0, 0.9);
    z-index: 10000;
}
.video-bg {
}
.video-close {
    cursor: pointer;
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 3200;
}
.video-close i {
    transition: opacity 0.4s ease-in-out;
    font-size: 20px;
    color: #fff;
}
.video-content {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 3000;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
}
.video-content video {
    width: 100%;
    height: 100%;
}
@media screen and (max-width:450px){
    .banner .swiper-pagination{
        width:30%;
        left:35%;
    }
}
</style>
